import { Schema } from '@coveo/bueno';
import { executeSearch } from '../../features/search/search-actions.js';
import { deselectAllStaticFilterValues, logStaticFilterClearAll, logStaticFilterDeselect, logStaticFilterSelect, registerStaticFilter, toggleExcludeStaticFilterValue, toggleSelectStaticFilterValue, } from '../../features/static-filter-set/static-filter-set-actions.js';
import { staticFilterIdSchema, staticFilterValuesSchema, } from '../../features/static-filter-set/static-filter-set-schema.js';
import { staticFilterSetReducer as staticFilterSet } from '../../features/static-filter-set/static-filter-set-slice.js';
import { loadReducerError } from '../../utils/errors.js';
import { validateOptions } from '../../utils/validate-payload.js';
import { buildController, } from '../controller/headless-controller.js';
import { buildStaticFilterValue, } from './static-filter-value.js';
export { buildStaticFilterValue };
const optionsSchema = new Schema({
    id: staticFilterIdSchema,
    values: staticFilterValuesSchema,
});
/**
 * Creates a `Static Filter` controller instance.
 *
 * @param engine - The headless engine.
 * @param props - The configurable `Sort` controller properties.
 * @returns A `Sort` controller instance.
 *
 * @group Controllers
 * @category StaticFilter
 */
export function buildStaticFilter(engine, props) {
    if (!loadReducers(engine)) {
        throw loadReducerError;
    }
    validateOptions(engine, optionsSchema, props.options, 'buildStaticFilter');
    const controller = buildController(engine);
    const { dispatch } = engine;
    const getState = () => engine.state;
    const { id } = props.options;
    dispatch(registerStaticFilter(props.options));
    return {
        ...controller,
        toggleSelect(value) {
            dispatch(toggleSelectStaticFilterValue({ id, value }));
            dispatch(executeSearch({
                legacy: getLegacyAnalyticsActionForToggledValue(id, value),
            }));
        },
        toggleSingleSelect(value) {
            if (value.state === 'idle') {
                dispatch(deselectAllStaticFilterValues(id));
            }
            dispatch(toggleSelectStaticFilterValue({ id, value }));
            dispatch(executeSearch({
                legacy: getLegacyAnalyticsActionForToggledValue(id, value),
            }));
        },
        toggleExclude(value) {
            dispatch(toggleExcludeStaticFilterValue({ id, value }));
            dispatch(executeSearch({
                legacy: getLegacyAnalyticsActionForToggledValue(id, value),
            }));
        },
        toggleSingleExclude(value) {
            if (value.state === 'idle') {
                dispatch(deselectAllStaticFilterValues(id));
            }
            dispatch(toggleExcludeStaticFilterValue({ id, value }));
            dispatch(executeSearch({
                legacy: getLegacyAnalyticsActionForToggledValue(id, value),
            }));
        },
        deselectAll() {
            dispatch(deselectAllStaticFilterValues(id));
            dispatch(executeSearch({
                legacy: logStaticFilterClearAll({ staticFilterId: id }),
            }));
        },
        isValueSelected(value) {
            return value.state === 'selected';
        },
        isValueExcluded(value) {
            return value.state === 'excluded';
        },
        get state() {
            const values = getState().staticFilterSet[id]?.values || [];
            const hasActiveValues = values.some((value) => value.state !== 'idle');
            return {
                id,
                values,
                hasActiveValues,
            };
        },
    };
}
function loadReducers(engine) {
    engine.addReducers({ staticFilterSet });
    return true;
}
function getLegacyAnalyticsActionForToggledValue(id, value) {
    const { caption, expression, state } = value;
    const analytics = state === 'idle' ? logStaticFilterSelect : logStaticFilterDeselect;
    return analytics({
        staticFilterId: id,
        staticFilterValue: { caption, expression },
    });
}
